<template>
    <div class="devive_comms">
            <!-- FILTER -->
            <form>
                <input id="startDate" type="date"/> <input id="time" type="time" step="2" name="appt-time"/>TO
                <input id="endDate" type="date"/> <input id="time1" type="time" step="2" name="appt-time"/> 
                <input id="limit" type="number" placeholder="Enter limit" style="max-width: 50px;">
            <button type="button" class="btn btn-info btn-sm" @click="getNewData()">GetData/Date</button>
            <router-link to="/DeviceList" class="btn btn-danger btn-sm" type="button" >Back</router-link>
            </form>
        <div class="mechines bg-secondary table-responsive">
            <table class="table table-hover table-dark" id="myTable">
            <thead>
                <tr>
                <th scope="col">DeviceID</th>
                <!-- <th scope="col" id="pulses">Pulses</th> -->
                <th scope="col">Digital<br>State</th>
                <th scope="col">FW<br>Version</th>
                <th scope="col">HW<br>Version</th>
                <th scope="col">
                  
                <!-- Sort by MessageCount -->
                   <button @click="sortBy('MessageCount')" class="sort-btn">
                        Message<br>Count      
                      <span class="arrow" v-if="sortColumn === 'MessageCount' && sortDirection === 'asc'">▲</span>
                      <span class="arrow" v-else-if="sortColumn === 'MessageCount' && sortDirection === 'desc'">▼</span>
                      <span class="arrow" v-else>⇅</span>
                  </button>
                <!-- End Sort by MessageCount -->
                </th>
                <th scope="col">
                    <button @click="sortBy('EventCount')" class="sort-btn">
                      Event<br>Count
                      <span class="arrow" v-if="sortColumn === 'EventCount' && sortDirection === 'asc'">▲</span>
                      <span class="arrow" v-else-if="sortColumn === 'EventCount' && sortDirection === 'desc'">▼</span>
                      <span class="arrow" v-else>⇅</span>
                  </button>
                </th>
                <th scope="col">POST<br>Interval</th>
                <th scope="col">Packet<br>Type</th>
                <th scope="col">Pulse<br>Count</th>
                <th scope="col">curr_product</th>
                <th scope="col">deltaPulses</th>
                <th scope="col">Difference<br>InSeconds</th>
                <th scope="col">WiFi<br>RSSI</th>
                <th scope="col">WiFiSSID</th>
                <th scope="col">
                  <button @click="sortBy('DateTimeUTC')" class="sort-btn">
                    DateTime
                    <span class="arrow" v-if="sortColumn === 'DateTimeUTC' && sortDirection === 'asc'">▲</span>
                    <span class="arrow" v-else-if="sortColumn === 'DateTimeUTC' && sortDirection === 'desc'">▼</span>
                    <span class="arrow" v-else>⇅</span>
                  </button>
                </th>
                </tr>
            </thead>
            <div class="missed_msg mb-2">
              <strong>Missed Messages:</strong> {{ missedData.missedTotal }}
            </div>
            <tbody>
                <tr v-for="(message, index) in sortedMessages" :key="index" 
                :class="{ highlight: missedData.highlighted.has(index) }">
                <td style="text-transform: uppercase;">{{ message.DeviceId }}</td>
                <td>{{ message.DigitalState }}</td>
                <td>{{ message.FWVersion }}</td>
                <td>{{ message.HWVersion }}</td>
                <td>{{ message.MessageCount }}</td>
                <td>{{ message.EventCount }}</td>
                <td>{{ message.POSTInterval }}</td>
                <td>{{ message.PacketType }}</td>
                <td>{{ message.PulseCount }}</td>
                <td>{{ message.curr_product }}</td>
                <td>{{ message.deltaPulses }}</td>
                <td>{{ message.differenceInSeconds }}</td>
                <td>{{ message.WiFiRSSI }}</td>
                <td>{{ message.WiFiSSID }}</td>
                <td class="date">{{ new Date(message.DateTimeUTC + "Z").toLocaleString('en-GB') }}</td>
                </tr>
             </tbody>
            </table>
         </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            messages: [],
            sortColumn: '',
            sortDirection: 'desc'
        }
    },
mounted() {
    this.getData()
},

computed: {
  missedData() {
    const highlighted = new Set();
    let missedTotal = 0;

    // Sort descending (latest to oldest) based on MessageCount as number
    const sorted = [...this.messages].sort(
      (a, b) => Number(b.MessageCount) - Number(a.MessageCount)
    );

    for (let i = 0; i < sorted.length - 1; i++) {
      const currentCount = Number(sorted[i].MessageCount);
      const nextCount = Number(sorted[i + 1].MessageCount);

      // Skip resets or duplicates (e.g., restart or duplicate message)
      if (nextCount >= currentCount) continue;

      const diff = currentCount - nextCount;

      if (diff > 1) {
        missedTotal += diff - 1;
        highlighted.add(i); // highlight the row before the gap
      }
    }
    return {
      missedTotal,
      highlighted
    };
  },

    sortedMessages() { //Sort existing messages here
    if (!this.sortColumn) return this.messages;
    return [...this.messages].sort((a, b) => {
      let valA = a[this.sortColumn];
      let valB = b[this.sortColumn];
      if (this.sortColumn === 'DateTimeUTC') {
        valA = new Date(valA + 'Z');
        valB = new Date(valB + 'Z');
      } else {
        valA = Number(valA);
        valB = Number(valB);
      }
      if (this.sortDirection === 'asc') {
        return valA > valB ? 1 : valA < valB ? -1 : 0;
      } else {
        return valA < valB ? 1 : valA > valB ? -1 : 0;
      }
    });
  }
},

methods: {
  //API CALL AND DATA FORMART
    getData() {
      //CLEAR CHAT 
      if (this.ctx){
         this.chartData = [],
         this.dates = []
       }
      //FORMAT DATE FILTER
      var d = new Date();
      var endDate = new Date();
      endDate.setDate(endDate.getDate())
      let time = "06" + ":" + "00" + ":" + "00";
      let time1 = "18" + ":" + "00" + ":" + "00";
      document.getElementById('startDate').valueAsDate = d;
      document.getElementById('endDate').valueAsDate = endDate;
      document.querySelector('input[id="time"]').value = time;
      document.querySelector('input[id="time1"]').value = time1;
      this.to_date = new Date(document.getElementById("endDate").value + " " + document.getElementById('time1').value).toISOString();
      let DeviceId = this.$route.params.DeviceId
      this.from_date = new Date(document.getElementById('startDate').value + " "+ document.getElementById('time').value).toISOString();
      var limit = document.getElementById('limit').value = 15
       //API CALL
        axios.get('https://m4a.ramacsystems.com/backend/devices/getDeviceDetails.php?params=', {
          params: {
            DeviceId,
             from_date: this.from_date,
             to_date: this.to_date,
             limit: limit
          }
        })
        //RESPONSE AND RENDER CHART
        .then((response) => {
           this.messages = response.data
       })
          .catch(error => console.log(error))
     },

     getNewData() {
       let to_date = new Date(document.getElementById("endDate").value + " " + document.getElementById('time1').value).toISOString();
       //console.log('TO DATE - ' + to_date)
       let DeviceId = this.$route.params.DeviceId
       let from_date = new Date(document.getElementById('startDate').value + " "+ document.getElementById('time').value).toISOString();
      // console.log('FROM DATE - ' + from_date)
       var limit = document.getElementById('limit').value
        //API CALL
        axios.get('https://m4a.ramacsystems.com/backend/devices/getDeviceDetails.php?params=', {
          params: {
            DeviceId,
             from_date: from_date,
             to_date: to_date,
             limit: limit
          }
        })
      //RESPONSE AND RENDER CHART
      .then((response) => {
           this.messages = response.data
           console.log(this.messages)
       })
     },
    sortBy(column) {
        if (this.sortColumn === column) {
          this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
          this.sortColumn = column;
          this.sortDirection = 'desc';
        }
  },

    back() {
      this.$router.go(-1)
      }
    },

}
</script>
<style scoped>
form {
   float: right;
   margin-right: 30px;
   margin-bottom: 10px;
   }
input {
  border-radius: 7px;
  border: solid 1px lightblue;
}
.btn {
  margin-left: 10px;
}

.no_records {
    text-transform: uppercase;
    margin-top: 100px;
    text-align: center;
    color: #fff;
}

.mechines {
  overflow-y: auto;
  height: 800px;
}

.mechines table {
  border-collapse: collapse;
  width: 100% !important;
}

.mechines th,
.mechines td {
  padding: 8px 16px;
}

.mechines th {
  position: sticky;
  top: 0;
  background: #303a3a;
}

#maxRows {
  max-width: 100px;
  border-radius: 7px;
  border: solid 1px lightblue;
  margin-right: 550px;
  padding: 5px;
}
.pagination-container {
  margin-left: 10px;
}

.highlight {
  background-color: rgba(255, 0, 0, 0.3); /* light red */
}

.missed_msg {
  color: #eea318;
  font-weight: bold;
  margin-bottom: 10px;
}

.date {
  min-width: 200px;
}

.sort-btn {
    background: #303a3a;
    border: none;
    color: #fff;
    cursor: pointer;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
}

.arrow {
  color: #6aaee6;
  font-weight: bold;
}

.sort-btn:hover,
.sort-btn:focus {
    border: none;
    color: #71adf3;
    cursor: pointer;
    font-style: italic;
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
}

.arrow {
  color: #6aaee6;
  font-weight: bold;
}
</style>